module.exports = "../../static/img/no-data.85c3b6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/no-data.png
// module id = /a04
// module chunks = 36